import { aoExibirPagina } from './v2/config';
import { iniciarMedicaoPagina, registrarEvento } from './v2/medicao';
import { fecharCompartilhar, iniciarVaga } from './v2/vaga';

// Página da vaga (M3): o mesmo detalhe do painel da busca, já no HTML do servidor. O js/v2/vaga.js (modo página) cuida
// do botão de candidatura, do salvar, do compartilhar e da denúncia; aqui fica a origem da campanha. A pílula da busca do
// celular é do topo (js/v2/topo.js), que baixa a busca em tela cheia no primeiro toque.
const $ = id => document.getElementById(id);
const lerJson = id => { try { return JSON.parse($(id)?.textContent || 'null'); } catch { return null; } };

const V = lerJson('vaga-v2') || {};
const T = lerJson('busca-v2-textos') || {};

function iniciarEventos() {
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !document.querySelector('dialog[open]')) {
            fecharCompartilhar();
        }
    });
}

// Origem da campanha (?campanha ou ?source): o cookie que o cadastro e a candidatura leem, por 1 dia, cru como no v1 (salvarCookie.js).
function definirOrigemCadastro() {
    const q = new URLSearchParams(window.location.search);
    const origem = q.get('campanha') || q.get('source');
    if (origem) {
        document.cookie = `origemCadastro=${origem}; expires=${new Date(Date.now() + 864e5).toUTCString()}; path=/`;
    }
}

// A linha de cima do detalhe gruda embaixo do topo, que muda de altura com a fonte do aparelho.
function ajustarTopo() {
    document.documentElement.style.setProperty('--vpg-topo', `${document.querySelector('.site-h')?.offsetHeight || 69}px`);
}

// ---------- início ----------
ajustarTopo();
window.addEventListener('resize', ajustarTopo, { passive: true });
iniciarMedicaoPagina('vaga');
registrarEvento('vaga_aberta', { origem: 'pagina', vaga_id: V.id });
aoExibirPagina(definirOrigemCadastro); // pré-renderizada pelo app, a origem da campanha só vale quando a pessoa abre
iniciarVaga({ textos: T, pagina: V.id });
iniciarEventos();
